// —— REST helpers ——————————————————————————————
import { API_ENDPOINT, useJwtToken } from 'helper';
import { useQuery } from 'react-query';

export const inviteUser = async (payload, accessToken) => {
    try {
        const response = await fetch(`${API_ENDPOINT}/users`, {
            method: 'POST',
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw errorData;
        }
        // Lambda often returns an empty body; treat that as success
        return response;
    } catch (error) {
        throw error;
    }
};

export const fetchUsersList = async (
    usersType,
    accessToken,
    limit,
    nextToken = null
) => {
    try {
        const response = await fetch(
            `${API_ENDPOINT}/users?usersType=${usersType}&limit=${limit}&nextToken=${nextToken}`,
            {
                method: 'GET',
                headers: {
                    Authorization: accessToken,
                },
            }
        );
        if (!response.ok) throw new Error(response.text());
        return response.json();
    } catch (error) {
        throw error;
    }
};

export const useUsersList = (usersType, limit, nextToken = null) => {
    const accessToken = useJwtToken();
    return useQuery(
        ['usersList', usersType, nextToken],
        async () =>
            await fetchUsersList(usersType, accessToken, limit, nextToken),
        {
            enabled: !!accessToken && !!usersType,
        }
    );
};

export const updateUser = async (usersType, newUserInfo, accessToken) => {
    const {
        userId,
        email,
        phone_number,
        address,
        name,
        family_name,
        companyId,
    } = newUserInfo;

    const isCustomer = usersType === 'Customer';

    const input = {
        [isCustomer ? 'Customer_ID' : 'Installer_ID']: userId,
        Email: email,
        Phone: phone_number,
        Name: `${name} ${family_name}`,
    };

    if (isCustomer) {
        input.Address = address;
    } else {
        input.CompanyID = companyId;
    }
    try {
        if (usersType === 'Admin' || usersType === 'CompanyAdmin') {
            return null;
        }
        const response = await fetch(
            `${API_ENDPOINT}/users/update-info?usersType=${usersType}`,
            {
                method: 'PATCH',
                headers: {
                    Authorization: accessToken,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(input),
            }
        );
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText);
        }
        return response.json();
    } catch (error) {
        throw error;
    }
};
